/** Серверный X-Task-ID должен быть UUID, прежде чем попадёт в путь /task/{id}. */
export function isTaskId(value: string | null): value is string {
    return (
        value !== null &&
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
            value,
        )
    )
}
